import React, { Component } from 'react';
import { withRouter, Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { Button } from 'reactstrap';
import Page from '~/components/page/page';
import TitleBar from '~/components/titleBar/titleBar';
import TransferScheduleEditForm from '~/containers/transferScheduleEdit/transferScheduleEdit';
import TransferScheduleArchive from '~/containers/transferScheduleArchive/transferScheduleArchive';

export class TransferScheduleEditPage extends Component {
  state = {
    transferSchedule: null
  };

  onReceiveTransferSchedule = ({ transferSchedule }) => {
    this.setState({
      transferSchedule
    });
  };

  render() {
    const transferScheduleId = this.props.match.params.transferScheduleId;
    const { transferSchedule } = this.state;

    const editButton = (
      <div className="flex">
        <TransferScheduleArchive className="mr4" transferSchedule={transferSchedule} />
        <Link to={`/settings/transfers/${transferScheduleId}`}>
          <Button color="secondary">Cancel</Button>
        </Link>
      </div>
    );

    return (
      <Page>
        <TitleBar
          back="/settings/transfers"
          backText="Transfer Schedules"
          title={transferSchedule ? transferSchedule.name : '...'}
          button={editButton}
        />
        <TransferScheduleEditForm onCompleted={this.onReceiveTransferSchedule} id={transferScheduleId} />
      </Page>
    );
  }
}

export default connect(state => ({
  brewery: state.brewery
}))(withRouter(TransferScheduleEditPage));



// WEBPACK FOOTER //
// ./src/pages/transferScheduleEdit/transferScheduleEdit.jsx